module.exports = __webpack_public_path__ + "static/media/arrowRight.613c1613.svg";